<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title
      >{{'Dados do' | translate}} {{tipoGrupo == 1 ? ('grupos' | nomenclatura | async) : ('ministerios' | nomenclatura |
      async)}}</ion-title
    >
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>
  <div>
    <form
      class="sample-form validations-form"
      [formGroup]="validations_form"
      (ngSubmit)="onSubmit(validations_form.value)"
    >
      <ion-grid>
        <ion-row>
          <ion-col>
            <ion-item lines="none">
              <ion-select
                label="{{'Tipo' | translate}}"
                labelPlacement="floating"
                interface="action-sheet"
                cancelText="{{ 'Cancelar' | translate}}"
                okText="{{ 'Confirmar' | translate}}"
                formControlName="tipo"
              >
                <ion-select-option *ngFor="let tipo of tipoList" [value]="tipo.id"> {{tipo.nome}} </ion-select-option>
              </ion-select>

              <div class="validation-errors">
                <ng-container *ngFor="let validation of validation_messages.tipo">
                  <div
                    class="error-message"
                    *ngIf="validations_form.get('tipo')?.hasError(validation.type) && (validations_form.get('tipo')?.dirty || validations_form.get('tipo')?.touched)"
                  >
                    {{ validation.message }}
                  </div>
                </ng-container>
              </div>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-item lines="none">
              <ion-input
                label="{{'Nome' | translate}}"
                labelPlacement="floating"
                formControlName="nome"
                type="text"
                placeholder="{{'Nome' | translate}}"
              >
              </ion-input>

              <div class="validation-errors">
                <ng-container *ngFor="let validation of validation_messages.nome">
                  <div
                    class="error-message"
                    *ngIf="validations_form.get('nome')?.hasError(validation.type) && (validations_form.get('nome')?.dirty || validations_form.get('nome')?.touched)"
                  >
                    {{ validation.message }}
                  </div>
                </ng-container>
              </div>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-item lines="none">
              <ion-select
                label="{{'Situação' | translate}}"
                labelPlacement="floating"
                interface="action-sheet"
                cancelText="{{ 'Cancelar' | translate}}"
                okText="{{ 'Confirmar' | translate}}"
                formControlName="idStatus"
                [disabled]="!idGrupo"
              >
                <ion-select-option *ngFor="let status of statusList" [value]="status.id">
                  {{status.nome}}
                </ion-select-option>
              </ion-select>

              <div class="validation-errors">
                <ng-container *ngFor="let validation of validation_messages.idStatus">
                  <div
                    class="error-message"
                    *ngIf="validations_form.get('idStatus')?.hasError(validation.type) && (validations_form.get('idStatus')?.dirty || validations_form.get('idStatus')?.touched)"
                  >
                    {{ validation.message }}
                  </div>
                </ng-container>
              </div>
            </ion-item>
          </ion-col>
        </ion-row>

        <ng-container>
          <prover-datepicker
            [labelName]="'Data'"
            [id]="'dataCriacao'"
            formControlName="dataCriacao"
            [required]="true"
          ></prover-datepicker>

          <div class="validation-errors">
            <ng-container *ngFor="let validation of validation_messages.dataCriacao">
              <div
                class="error-message"
                *ngIf="validations_form.get('dataCriacao')?.hasError(validation.type) && (validations_form.get('dataCriacao')?.dirty || validations_form.get('dataCriacao')?.touched)"
              >
                {{ validation.message }}
              </div>
            </ng-container>
          </div>
        </ng-container>

        <ion-row>
          <ion-col>
            <ion-item lines="none">
              <ion-input
                label="{{'Limite de Pessoas' | translate}}"
                labelPlacement="floating"
                formControlName="limitePessoas"
                type="text"
                placeholder="{{'Limite de Pessoas' | translate}}"
              >
              </ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-item lines="none">
              <ion-select
                label="{{'Vinculada à Rede' | translate}}"
                labelPlacement="floating"
                interface="action-sheet"
                cancelText="{{ 'Cancelar' | translate}}"
                okText="{{ 'Confirmar' | translate}}"
                formControlName="idGrupoHierarquia"
              >
                <ion-select-option *ngFor="let hierarquia of hierarquiaList" [value]="hierarquia.id">
                  {{hierarquia.nome}}
                </ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-item lines="none">
              <ion-select
                label="{{'Ciclo' | translate}}"
                labelPlacement="floating"
                interface="action-sheet"
                cancelText="{{ 'Cancelar' | translate}}"
                okText="{{ 'Confirmar' | translate}}"
                formControlName="idGrupoCiclo"
              >
                <ion-select-option *ngFor="let ciclo of grupoCicloList" [value]="ciclo.id">
                  {{ciclo.nome}}
                </ion-select-option>
              </ion-select>
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item lines="none">
              <div class="input-tel">
                <ion-label>{{'Celular' | translate}}</ion-label>
                <input #phoneCelular type="tel" [mask]="maskMap.get('phoneCelular')" formControlName="telCelular" />
              </div>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-item lines="none">
              <div class="input-tel">
                <ion-label>{{'Telefone Contato' | translate}}</ion-label>
                <input #phoneContato type="tel" [mask]="maskMap.get('phoneContato')" formControlName="telResidencial" />
              </div>
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-item lines="none">
              <ion-input
                label="{{'E-mail' | translate}}"
                label-placement="stacked"
                placeholder="{{'E-mail' | translate}}"
                type="email"
                [email]="validations_form.get('email')?.value!==''"
                formControlName="email"
              >
                <span class="danger">*</span>
              </ion-input>
            </ion-item>
          </ion-col>
        </ion-row>
      </ion-grid>
      <div class="validation-errors">
        <ng-container *ngFor="let validation of validation_messages.email">
          <div
            class="error-message"
            *ngIf="validations_form.get('email')?.hasError(validation.type) && (validations_form.get('email')?.dirty || validations_form.get('email')?.touched)"
          >
            {{ validation.message }}
          </div>
        </ng-container>
      </div>

      <div class="down">
        <ion-button class="btn-success" expand="block" type="submit" [disabled]="!validations_form.valid">
          {{'Salvar' | translate}}
        </ion-button>
      </div>
    </form>
  </div>
</ion-content>
